var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, persistent: "", "max-width": "750" },
      on: {
        "click:outside": function($event) {
          return _vm.closeDialog()
        }
      }
    },
    [
      _c(
        "v-card",
        { attrs: { color: "fill" } },
        [
          _c(
            "v-container",
            { staticClass: "shipperCon" },
            [
              _c(
                "v-card-title",
                { staticClass: "my-0 py-0 pt-0 heading-6" },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "my-2",
                      attrs: { justify: "space-between" }
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pb-4",
                          attrs: { align: "start" }
                        },
                        [
                          _c("div", { staticClass: "text-no-wrap" }, [
                            _vm._v(
                              "\n              Item #" +
                                _vm._s(_vm.selectedItem.item_id) +
                                " Components\n            "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-0 ma-0 pr-1",
                          attrs: { align: "end" }
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.generateCSV()
                                                }
                                              }
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { dense: "" } },
                                            [_vm._v("mdi-download")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [_vm._v(" "), _c("span", [_vm._v("Export CSV")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  return _vm.closeDialog()
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { dense: "" } }, [
                                _vm._v("mdi-close")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              [
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.selectedItem.components,
                    "item-key": "uuid",
                    "hide-default-footer": "",
                    "fixed-header": "",
                    dense: ""
                  },
                  on: {
                    "update:items": function($event) {
                      return _vm.$set(_vm.selectedItem, "components", $event)
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "item.upc",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c("td", { staticClass: "text-no-wrap" }, [
                              _vm._v(_vm._s(item.component_upc))
                            ])
                          ]
                        }
                      },
                      {
                        key: "item.description",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c("td", { staticClass: "text-no-wrap" }, [
                              _vm._v(
                                _vm._s(
                                  item.component_description
                                    ? item.component_description
                                    : "-"
                                )
                              )
                            ])
                          ]
                        }
                      },
                      {
                        key: "item.shelf_unit",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c("td", { staticClass: "text-no-wrap" }, [
                              _vm._v(_vm._s(item.shelf_unit))
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ]
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ed8aaf1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ed8aaf1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShipperComponentModal.vue
// module id = null
// module chunks = 